import { GetterTree } from 'vuex';
import Dashboard, {
  // TopChannel,
  Destination,
  RecentShipment, ScheduledPickup, DashboardSettings, Widgets, Transits,
} from '../types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getters: GetterTree<Dashboard, any> = {
  getWidgets(state: Dashboard): Widgets {
    return state.widgets;
  },

  getPositionOfFirstWidget(state: Dashboard): number {
    const widgetElements = Object.entries(state.widgets).map((el) => {
      return {
        ...el[1],
      };
    });

    let widgets = widgetElements.filter(
      (widget) => widget.show === true && widget.size === 'big',
    );

    if (!widgets.length) {
      widgets = widgetElements.filter(
        (widget) => widget.show === true && widget.size === 'small',
      );
    }

    if (!widgets.length) return 0;

    return widgets.sort((a, b) => {
      return a.position - b.position;
    })[0].position;
  },

  getIsBigWidgetAvailable(state: Dashboard): boolean {
    const widgets = Object.entries(state.widgets).map((el) => {
      return {
        ...el[1],
      };
    }).filter((widget) => widget.show === true && widget.size === 'big');

    return !!widgets.length;
  },

  getIsSmallWidgetAvailable(state: Dashboard): boolean {
    const widgets = Object.entries(state.widgets).map((el) => {
      return {
        ...el[1],
        key: el[0],
      };
    }).filter((widget) => widget.show === true
      && widget.size === 'small' && widget.key !== 'shippingTips');

    return !!widgets.length;
  },

  getHasShipped(state: Dashboard): boolean {
    return state.dashboardSettings.hasShipped;
  },

  getRecentShipments(state: Dashboard): Array<RecentShipment> | undefined {
    return state.widgets.recentShipments.shipments;
  },

  getScheduledPickups(state: Dashboard): Array<ScheduledPickup> | undefined {
    return state.widgets.scheduledPickups.pickups;
  },

  getTopDestinations(state: Dashboard): Array<Destination> | undefined {
    return state.widgets.topDestinations.destinations;
  },

  getTransits(state: Dashboard): Transits | undefined {
    return state.widgets.transitStatus.transits;
  },

  // getTopChannels(state: Dashboard): Array<TopChannel> | undefined {
  //   return state.widgets.topChannels.channels;
  // },

  getDashboardSettings(state: Dashboard): DashboardSettings | undefined {
    return state.dashboardSettings;
  },

  getIsDashboardSettings(state: Dashboard): number {
    return state.isDashboardSettings;
  },

  getUsersName(state: Dashboard): string | undefined {
    return state.dashboardSettings?.firstname;
  },

  // getTimeOfDay(state: Dashboard): string | undefined {
  //   return state.dashboardSettings?.timeOfDay;
  // },

  getShowCustomizeTooltip(state: Dashboard): boolean {
    return state.showCustomizeTooltip;
  },

  getCustomizeTooltipStep(state: Dashboard): number {
    return state.customizeTooltipStep;
  },
};

export default getters;
